export default {"src":"/_next/static/media/discovery_goal_setting.1a0bc850.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};